import { cnpj, cpf } from 'cpf-cnpj-validator';
import moment from 'moment';
import * as yup from 'yup';

import { userExists } from '../../services/user';
import { cpfExists } from '../../services/user';

yup.setLocale({
  mixed: {
    required: 'Voce deixou esse campo em branco',
  },
  string: {
    // eslint-disable-next-line no-template-curly-in-string
    min: 'O campo deve ter no mínimo ${min} caracteres',
  }
});

let emailsValidated = {};
let cpfsValidated = {};

export const clearEmailsValidated = () => {
  emailsValidated = {};
};

export const clearCpfsValidated = () => {
  cpfsValidated = {};
};

const registerSchemaCpf = yup.object().shape({
  email: yup
    .string()
    .required()
    .email('E-mail inválido')
    .test('is-valid-email-format', 'E-mail inválido', (value) => {
      const pattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
      return pattern.test(value);
    })
    .test('is-already-email-exists', 'Email já existe', async (value) => {
      if (!(await yup.string().email().isValid(value)) || !value) {
        return true;
      }
      if (emailsValidated[value] === undefined) {
        try {
          await userExists({ email: value });
          emailsValidated[value] = false;
        } catch (err) {
          emailsValidated[value] = true;
        }
      }

      return emailsValidated[value];
    }),
  document: yup
    .string()
    .required()
    .test('is-valid-document',
      'CPF/CNPJ já esta em uso', async (value) => {
        console.log(value);
        if (!(cpf.isValid(value) || cnpj.isValid(value)) || !value) {
          return true;
        }

        if (cpfsValidated[value] === undefined) {
          try {
            await cpfExists({ cpf: value });
            cpfsValidated[value] = false;
          } catch (err) {
            cpfsValidated[value] = true;
          }
        }

        return cpfsValidated[value];
      }),
  name: yup.string()
    .required()
    .test(
      'has-surname',
      'Por favor, informe nome e sobrenome',
      (value) => {
        if (!value) return false;
        const parts = value.trim().split(/\s+/);
        return parts.length >= 2 && parts[1].length > 0;
      }
    )
    .test(
      'name-min-length',
      'O nome deve ter no mínimo 2 caracteres',
      (value) => {
        if (!value) return false;
        const parts = value.trim().split(/\s+/);
        return parts[0] && parts[0].length >= 2;
      }
    )
    .test(
      'surname-min-length',
      'O sobrenome deve ter no mínimo 2 caracteres',
      (value) => {
        if (!value) return false;
        const parts = value.trim().split(/\s+/);
        return parts[1] && parts[1].length >= 2;
      }
    )
    .test(
      'name-max-length',
      'O nome completo deve ter no máximo 200 caracteres',
      (value) => {
        if (!value) return true;
        return value.trim().length <= 200;
      }
    ),
  password: yup
    .string()
    .required()
    .min(8)
    .test(
      'strong-password',
      'A senha não cumpre os requisitos, veja abaixo:',
      (value) => {
        if (!value) {
          return false;
        }
        if (
          value.match(/[0-9]+/g) &&
          value.match(/[A-Z]+/g) &&
          value.match(/[a-z]+/g)
        ) {
          return true;
        }

        return false;
      }
    ),
  password_confirmation: yup
    .string()
    .required()
    .oneOf([yup.ref('password'), null], 'Senhas diferentes, confira novamente'),
  birthdate: yup
    .string()
    .required()
    .test(
      'complete-birthdate',
      'Data de nascimento incompleta',
      (value) => {
        if (!value) return false;
        return value.replace(/\D/g, '').length === 8 && value.length >= 10;
      }
    )
    .test(
      'past-birthdate',
      'O campo não pode ser anterior à 01/01/1900',
      (value) => {
        const momentDate = moment(value, 'DD/MM/YYYY', true);
        return momentDate.isValid() && momentDate.isAfter('1899-12-31');
      }
    )
    .test('invalid-birthdate', 'O campo requer o formato dd/mm/aaaa', (value) =>
      moment(value, 'DD/MM/YYYY', true).isValid()
    ),
  telephone: yup.string().transform((value) => value.replace(/\D/g, ''))
    .min(11, 'Voce digitou o numero incompleto')
    .max(11, 'O número de telefone deve conter 11 dígitos')
    .required(),
  gender: yup.string().required(),
  gender_detail: yup.string().when("gender", {
    is: (val) => Number(val) === 3,
    then: yup.string().min(3).max(15)
      .test('min-max', 'O campo deve ter no mínimo 3 caracteres', (value) => value ? value.length > 2 : true)
      .test('max-carateres', 'O campo deve ter no máximo 15 caracteres', (value) => value ? value.length < 16 : true),
  })
});

export default registerSchemaCpf;
